
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import util from '@/javascript/util'
import EsQuery from "@/javascript/esQuery";
import loading from '@/components/public-components/loading/index.vue'
import home from '@/components/jts-components/home/index.vue'

export default {
directives: {
TransferDom
},
components: {
Previewer,
loading,
home
},
data () {
return {
minHeight: 0,
pageNo: 0,
pageSize: 10,
dataList: [],

}
},
created () {

},
mounted () {
this.minHeight = document.documentElement.clientHeight
document.title = this.PAGE_TITLE + '全景'
this.getData()
},
methods: {
getData() {
const _this = this
const querystring = require('querystring');
const dataEsQuery = new EsQuery()
dataEsQuery
.addStartWith("deptCode", "100010000300003", dataEsQuery.and, false)
.addStartWith("catalogCode", "00000000,1651108701126", dataEsQuery.and, false)
.addSort("weight", dataEsQuery.desc, false)
.addPage(_this.pageNo * _this.pageSize, _this.pageSize)
const dataEsJsonQuery = JSON.stringify(dataEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.newsList,
esJsonQuery: dataEsJsonQuery
})).then(function (res) {
_this.dataList = _this.dataList.concat(res.data.data)











})
},
jumpLink(link) {
window.location.href = link;
}
}
}
